export default __webpack_public_path__ + "static/media/Quiz_session.24ff28b8.svg";